import { StyleSheet } from 'react-native';
import { FONTS } from '../../constants';
import { STYLE_VARS } from '../../constants/style-vars';

export const formHelperStyled = StyleSheet.create({
  formInputWrapper: {
    marginBottom: 20,
  },
  formInputLable: {
    fontSize: 14,
    letterSpacing: 1.2,
    textTransform: 'uppercase',
    color: STYLE_VARS.kccTextGreen,
    fontWeight: '500',
    fontFamily: FONTS.IowanOldStyleBTRoman,
    marginBottom: 5,
  },
  formInput: {
    height: 40,
    paddingHorizontal: 10,
    paddingVertical: 5,
    backgroundColor: STYLE_VARS.fccLightGrey,
    color: STYLE_VARS.fccDarkerGrey,
    fontSize: 12,
    // textTransform: 'uppercase',
    letterSpacing: 0.8,
    fontWeight: '500',
    fontFamily: FONTS.IowanOldStyleBTRoman,
  },
});
